<template>
  <SwitchGroup v-if="isEditing" as="div" class="flex items-center">
    <Switch @update:model-value="editItem"  v-model="toggleValue" :class="[toggleValue ? 'bg-nova-accent' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-nova-accent focus:ring-offset-2']">
      <span aria-hidden="true" :class="[toggleValue ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']" />
    </Switch>
    <SwitchLabel as="span" class="ml-3 text-xs">
      <span class="font-medium " :class="white ? 'text-white' : 'text-gray-900'">{{props.title}}</span>
      {{ ' ' }}
      <span class="text-gray-500 text-xs">{{props.subText}}</span>
    </SwitchLabel>
  </SwitchGroup>
  <div v-else>
    <div v-if="modelValue !== undefined" class="flex items-center text-sm">
      <span class="font-medium" :class="white ? 'text-white' : 'text-gray-900'">{{props.title}}</span>
      {{ ' ' }}
      <span class="ml-2" :class="white ? 'text-white' : 'text-gray-500'">{{modelValue ? props.selectedText : props.unselectedText}}</span>
    </div>
  </div>
</template>

<script setup>
import {ref, defineProps, defineEmits, watch, onMounted} from 'vue'
import { Switch, SwitchGroup, SwitchLabel } from '@headlessui/vue'
const emit = defineEmits(['update:modelValue', 'change']);
const props = defineProps({
  modelValue: Boolean,
  title: String,
  subText: String,
  selectedText: {
    type: String,
    default: 'Yes'
  },
  unselectedText: {
    type: String,
    default: 'No'
  },
  isEditing: {
    type: Boolean,
    default: true
  },
  white: {
    type: Boolean,
    default: false
  },
  storageKey: {
    type: String,
    default: ''
  },
  persist: {
    type: Boolean,
    default: true
  },
  defaultValue: {
    type: Boolean,
    default: false
  }
});

const toggleValue = ref(props.modelValue);

onMounted(() => {
  if (!props.persist || !props.storageKey || typeof window === 'undefined') return;
  try {
    const raw = window.localStorage.getItem(props.storageKey);
    if (raw !== null) {
      const stored = raw === 'true';
      toggleValue.value = stored;
      emit('update:modelValue', stored);
    } else if (props.modelValue === undefined) {
      toggleValue.value = props.defaultValue;
      emit('update:modelValue', props.defaultValue);
    }
  } catch (_) {
    // ignore storage errors
  }
});

watch(() => props.modelValue, (value) => {
  if (value === undefined) return;
  toggleValue.value = value;
});

const editItem = () => {
  const newVal = !toggleValue.value;
  toggleValue.value = newVal;
  emit('update:modelValue', newVal);
  emit('change', newVal);
  if (props.persist && props.storageKey && typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(props.storageKey, String(newVal));
    } catch (_) {
      // ignore storage errors
    }
  }
};
</script>